import {ApplicationController} from "../support/application-controller";
import {appendContentToNode, replaceContentInNode} from "../support/util";
import queryString from 'query-string';

export default class extends ApplicationController {
    static targets = [
        "list",
        "loadMore",
        "listContainer",
        "searchInput",
        "orderBy",
        "clearSearch",
        "searchField",
    ];

    connect() {
        if (!this.hasListTarget) return;

        this.clearInput();

        this.offset = this.listTarget.childElementCount;

        this.searchTerm = '';
        this.orderDirection = 'descending';
        if (this.orderBy && this.orderBy !== 'id') {
            this._setOrderBy('modifiedDate');
        }

        document.addEventListener('keyup', this.onOpenProject);
    }

    disconnect() {
        document.removeEventListener('keyup', this.onOpenProject);
    }

    onOpenProject = () => {
        if (event.key === 'Enter' && event.target.className.split(' ').includes('project')) {
            event.target.click();
        }
    }

    loadMore(e) {
        e.preventDefault();
        this._getProjects();
    }

    handleInput(e) {
        this._setInputValue(e.target.value.trim());
    }

    handleFocus(e) {
        this.searchFieldTarget.classList.add('search-field--focused');
    }

    handleBlur(e) {
        this._debounce(() => {
            this.searchFieldTarget.classList.remove('search-field--focused');
        }, 100)();
    }

    _setInputValue(input) {
        this.offset = 0;

        this.searchTerm = input;

        if (this.searchTerm !== '') this._showClearButton();
        else this._hideClearButton();

        this._debounce(() => {
            this._getProjects();
        }, 300)();
    }

    _showClearButton() {
        this.clearSearchTarget.classList.add('search-field__clear--visible');
    }

    _hideClearButton() {
        this.clearSearchTarget.classList.remove('search-field__clear--visible');
    }

    focusInput() {
        const searchInput = this.searchInputTarget;
        searchInput.focus();
    }

    clearInput() {
        this.searchInputTarget.value = '';
    }

    resetSearch() {
        this.clearInput();
        this._setInputValue('');
    }

    handleKeyUp(e) {
        const key = e.keyCode || e.which;
        if (key === 27) {
            this.resetSearch();
        }
    }

    _toggleOrderDirection(target) {
        this.orderDirection = this.orderDirection === 'ascending' ? 'descending' : 'ascending';
        // find and set selected state for order method
        if (this.orderDirection === 'ascending') target.classList.add('popup-list-item--flipped');
        else target.classList.remove('popup-list-item--flipped');
    }

    _resetOrderDirection(target) {
        this.orderDirection = 'descending';
        target.classList.remove('popup-list-item--flipped');
    }

    orderMapsBy(e) {
        this._setOrderBy(e.currentTarget.dataset.orderBy);
        this.offset = 0;

        this._getProjects();
    }

    _setOrderBy(orderByMethod) {
        const orderByTargets = this.orderByTargets;
        const oldOrderMethod = this.orderBy;
        const oldOrderTarget = orderByTargets.find(obt => obt.dataset.orderBy === oldOrderMethod);
        this.orderBy = orderByMethod;
        const newOrderTarget = orderByTargets.find(obt => obt.dataset.orderBy === this.orderBy);

        // if the clicked item is the same as before, just toggle the order direction
        if (oldOrderTarget === newOrderTarget) {
            this._toggleOrderDirection(oldOrderTarget);
            return;
        } else {
            if (newOrderTarget) this._resetOrderDirection(newOrderTarget);
        }

        // remove old selected state
        if (oldOrderMethod != undefined) {
            oldOrderTarget.classList.remove('popup-list-item--selected');
        }
        if (newOrderTarget) newOrderTarget.classList.add('popup-list-item--selected');
    }

    _getProjects() {
        const data = queryString.stringify({
            offset: this.offset,
            searchTerm: this.searchTerm,
            orderDirection: this.orderDirection,
            orderBy: this.orderBy,
        });

        this.railsGet({ data, url: this.dataSourceUrl, dataType: 'application/json' })
            .then(this._onResponse);
    }

    _onResponse = ({ html, canLoadMore, projectsLength }) => {
        const list = this.listTarget;
        const loadMore = this.loadMoreTarget;
        if (this.offset > 0) {
            appendContentToNode(list, html);
        } else {
            replaceContentInNode(list, html);
        }

        this.offset = this.offset + projectsLength;

        if (loadMore) loadMore.classList.toggle('hidden', !canLoadMore);
    };

    get dataSourceUrl() {
        return this.data.get("sourceUrl");
    }

    get orderDirection() {
        return this.data.get("orderDirection");
    }

    set orderDirection(value) {
        this.data.set("orderDirection", value);
    }

    get orderBy() {
        return this.data.get("orderBy");
    }

    set orderBy(value) {
        this.data.set("orderBy", value);
    }

    get offset() {
        return parseInt(this.data.get("offset"));
    }

    set offset(value) {
        this.data.set("offset", value);
    }

    get searchTerm() {
        return this.data.get("searchTerm");
    }

    set searchTerm(value) {
        this.data.set("searchTerm", value);
    }
}
